import styled from 'styled-components';

export const Page = styled.div`
  height: 100%;
  overflow-y: auto;
  padding-bottom: 64px;
  width: 100%;
`;
